module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/box-1-6ed72c3f29684ca3253ab10ba9c5c634.svg";